"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultLoadingFallback = DefaultLoadingFallback;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 *
 * @returns Activity indicator that takes the whole parent size and
 * shows a circular progress icon in the center.
 */
function DefaultLoadingFallback() {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("style", { children: `
      @keyframes identity-dash {
        0% {
          stroke-dashoffset: 140;
        }
        50% {
          stroke-dashoffset: 30;
          transform: rotate(135deg);
        }
        100% {
          stroke-dashoffset: 140;
          transform: rotate(450deg);
        }
      }
      
      @keyframes identity-rotator {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(270deg);
        }
      }
      ` }), (0, jsx_runtime_1.jsx)("div", { style: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                }, children: (0, jsx_runtime_1.jsx)("svg", { style: {
                        animation: 'identity-rotator 1.4s linear infinite',
                    }, width: "40px", height: "40px", viewBox: "0 0 40 40", xmlns: "http://www.w3.org/2000/svg", role: "progressbar", "aria-label": "loading", children: (0, jsx_runtime_1.jsx)("circle", { style: {
                            strokeDasharray: '140',
                            strokeDashoffset: '0',
                            transformOrigin: 'center',
                            stroke: '#1860CF',
                            animation: 'identity-dash 1.4s ease-in-out infinite',
                            WebkitAnimation: 'identity-dash 1.4s ease-in-out infinite',
                        }, fill: "none", strokeWidth: "3", cx: "20", cy: "20", r: "18" }) }) })] }));
}
